import React from 'react';

import * as customStyled from './styles';
import { ThumbnailMetadataProps } from '../../types';

const ThumbnailMetadata: React.FC<ThumbnailMetadataProps> = ({
  tags,
  overout,
  type
}) => {
  const renderGenres = () => {
    return tags.map((genre: string, index: number) => {
      return <span key={index}>{genre}</span>;
    });
  };

  return (
    <div css={customStyled.popupMetaDetails(overout, type)}>
      {renderGenres()}
    </div>
  );
};

export default ThumbnailMetadata;
